import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2)
  }
}))

export default useStyles
